<template>
  <div>
    <span
        v-on:click="linkAction"
        :class="[btnInverted ? btnThemeInverted : btnTheme ]"
    >
      {{ btnName }}
    </span>
  </div>
</template>

<script>

export default {
  props: {
    link: String,
    btnName: String,
    btnInverted: Number,
  },
  data() {
    return {
      btnTheme: 'btn btn-blue btn-lauren margin-top-15 width-340 padding-left-20 padding-right-20',
      btnThemeInverted: 'btn btn-lauren btn-blue btn-inverted width-300',
    }
  },
  methods: {
    linkAction: function () {
      window.location.href = this.link
    }
  }
}
</script>